import React, { useMemo, Fragment, useEffect, useState, useRef } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { MaterialReactTable } from 'material-react-table';
import { useGetLoggedInUserDetails } from "../../../../../hooksAndFunctions/customHooks/useGetLoggedInUserDetails";
import FormHelperText from '@mui/material/FormHelperText';
import sortBy from "lodash/sortBy";
import { useOutletContext } from 'react-router-dom';

const ManagePDFilesForSubFolderDialog = ({ open, setOpen, PDListFromAPI, parentItemObjData, targetItemObjData, compositeFolderArrayInsideRoot, setCompositeFolderArrayInsideRoot }) => {

    // console.log("PDList:", PDListFromAPI)

    const { loggedInUser } = useGetLoggedInUserDetails();
    const { emailAddress } = loggedInUser;


    const tableInstanceRef = useRef(null);

    /** */
    const handleClose = (event, reason) => {
        if (reason && reason == "backdropClick") {
            return '';
        } else {
            setOpen(false);
        }

        /**clear all selections */
        setRowSelection({})
    }

    const resourcesCMSData = useOutletContext();

    const fetchClientAccResDtlsLabel = (key) => {
        if (resourcesCMSData && resourcesCMSData?.pageContent["ClientAccountResourcesDetails"]) {
          const resourcesCMSDataLabel = resourcesCMSData.pageContent["ClientAccountResourcesDetails"];
          return returnLabel(resourcesCMSDataLabel?.Labels, key)
        }
    }

    const fetchCommonCMSLabel = (key) => {
        if (resourcesCMSData && resourcesCMSData?.pageContent["CommonComponent"]) {
            const commonCMSDataLabel = resourcesCMSData.pageContent["CommonComponent"];
            return returnLabel(commonCMSDataLabel?.Labels, key)
        }
        return '';
    }

    const returnLabel = (labelArray, key) => {
        if (labelArray.length > 0 && key) {
            return labelArray.find((x) => x.Key === key)?.Phrase || '';
        }
        return '';
    }

    const columns = useMemo(
        () => [
            {
                accessorKey: "ClientAccountProgramDescripitorTitle",
                id: 'ProgramDescripitorTitle',
                header: fetchClientAccResDtlsLabel ("ClientAccountResourcesDetails.ClientResourceTitle"), //"Client Resource Title",
                filterFn: 'contains',
                hide: true,
                muiTableHeadCellFilterTextFieldProps: 
                { placeholder: fetchClientAccResDtlsLabel ("ClientAccountResourcesDetails.PlaceholderClientResourceTitle") }
            },
            {
                accessorKey: "ProgramDescripitorFileName",
                header: fetchClientAccResDtlsLabel ("ClientAccountResourcesDetails.ResourceFileName"), //"Resource File Name",
                filterFn: 'contains',
                muiTableHeadCellFilterTextFieldProps: 
                { placeholder: fetchClientAccResDtlsLabel ("ClientAccountResourcesDetails.PlaceholderResourceFileName") }
            },
            {
                accessorKey: "ProgramDescripitorType",
                header: fetchClientAccResDtlsLabel ("ClientAccountResourcesDetails.ResourceType"), //"Resource Type",
                filterFn: 'contains',
                muiTableHeadCellFilterTextFieldProps: 
                { placeholder: fetchClientAccResDtlsLabel ("ClientAccountResourcesDetails.PlaceholderResourceType") }
            },
        ],
        []
    );

    //optionally, you can manage the row selection state yourself
    const [rowSelection, setRowSelection] = useState({});

    const pdListFromTargetObj = targetItemObjData?.ProgramDescriptors

    /**setting check box for already selected items */
    useEffect(() => {
        if (!!pdListFromTargetObj && !!pdListFromTargetObj?.length) {
            /**{1:true,23:true} to maintain state for selected item*/
            let obj = {}
            pdListFromTargetObj.forEach((item) => {
                return obj[`${item.ProgramDescripitorId}`] = true;
            })
            setRowSelection(obj)
        } else {
            setRowSelection({})
        }
    }, [targetItemObjData])

    /**collect PD ids selected sub-folders to disable their selection in same subfolder.
     * 
    */
    const pdListFromTargetSubFolder = targetItemObjData?.ProgramDescriptors

    let subFolderPDIIdList = []
    !!pdListFromTargetSubFolder && pdListFromTargetSubFolder.forEach((eachFile) => {
        const pdFile = eachFile?.ProgramDescripitorId
        subFolderPDIIdList.push(pdFile)
    })

    /**file count validation. max 20 file are allowed to create at each folder and sub folder level. */
    const [blockFileSelection, setBlockFileSelection] = useState(false)
    const [subfolderFileCountLimitMsg, setOSubFolderFileCountLimitMsg] = useState("")
    useEffect(() => {
        if (subFolderPDIIdList.length === 20 || subFolderPDIIdList.length > 20) {
            setOSubFolderFileCountLimitMsg("Max 20 resource file could be added at this level.  No more files can be added.")
            setBlockFileSelection(true)
        } else {
            setOSubFolderFileCountLimitMsg("")
            setBlockFileSelection(false)
        }
    }, [subFolderPDIIdList])


    const handleAddList = () => {
        /**get list of selected objects */
        const selectedRowObjList = tableInstanceRef.current
            .getSelectedRowModel()
            .rows.map((eachSelectedRowModel) => {

                return {
                    ProgramDescripitorId: eachSelectedRowModel?.original?.ProgramDescripitorId,
                    ClientAccountProgramDescripitorTitle: eachSelectedRowModel?.original?.ClientAccountProgramDescripitorTitle,
                    IsActive: eachSelectedRowModel?.original?.IsActive,
                    CreatedBy: emailAddress || ""
                }
            });

        // console.log("selectedItem:", selectedRowObjList)
        /**sort file array then set to  setRootFolderObject*/
        const inputArrayForSorting = selectedRowObjList || []

        const sortedFileArray = sortBy(inputArrayForSorting, function (item) {
            const clientAccountProgramDescripitorTitle = item?.ClientAccountProgramDescripitorTitle || ""
            /**we are converting all file names into smallcase for proper aphabetical order */
            return [clientAccountProgramDescripitorTitle.toLowerCase()];
        });

        const subfolderListFromParent = parentItemObjData?.ResourceSubFolders
        /**get parent Item and find subfolder and proccess pd files*/

        let modifiedSubFolderList = []
        !!subfolderListFromParent && subfolderListFromParent.forEach((item) => {
            if (item.Id === targetItemObjData.Id) {
                modifiedSubFolderList.push({
                    ...item,
                    ProgramDescriptors: sortedFileArray || []
                })
            } else {
                modifiedSubFolderList.push(item)
            }
        })

        const modifiedParentFolderObjWithModifiedSubfolders = {
            ...parentItemObjData,
            ResourceSubFolders: modifiedSubFolderList || []
        }

        // console.log("all-modifiedSubFolderList:", modifiedParentFolderObjWithModifiedSubfolders)

        /**adding modified parent object inside  compositeFolderArrayInsideRoot*/
        let newArray = []

        !!compositeFolderArrayInsideRoot && compositeFolderArrayInsideRoot.forEach((eachItem, index) => {

            if (eachItem?.Id === modifiedParentFolderObjWithModifiedSubfolders?.Id) {
                newArray.push(modifiedParentFolderObjWithModifiedSubfolders)
            } else {
                newArray.push(eachItem)
            }
        })

        setCompositeFolderArrayInsideRoot(newArray)

        handleClose()
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            disableEscapeKeyDown
        >
            <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
                {/* Select Programme Descriptor */}
                {fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.SelectProgrammeDescriptor')}
                <IconButton
                    sx={{ ml: 'auto' }}
                    onClick={handleClose}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                {
                    !!blockFileSelection && (
                        <FormHelperText error={!!blockFileSelection}>{subfolderFileCountLimitMsg}</FormHelperText>
                    )
                }
                <MaterialReactTable
                    tableInstanceRef={tableInstanceRef}
                    columns={columns}
                    data={PDListFromAPI || []}
                    // layoutMode="grid"
                    enableGlobalFilter={false}
                    enableDensityToggle={false}
                    initialState={{
                        density: 'compact',
                        showColumnFilters: true
                    }}
                    /**conditionally enable rows with checkbox, rest diable rows */
                    enableRowSelection={(row) => {
                        if (!!blockFileSelection) {
                            /** */
                            return false
                        } else {
                            return !subFolderPDIIdList.includes(row.original.ProgramDescripitorId)
                        }
                    }}
                    getRowId={(originalRow) => originalRow.ProgramDescripitorId}
                    onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                    state={{ rowSelection }}
                    enableStickyHeader
                    muiTablePaginationProps={{
                        labelRowsPerPage: fetchCommonCMSLabel('Common.Rowsperpage') //Rows per page
                      }}
                />

            </DialogContent>
            <DialogActions>
                <Button
                    type='button'
                    onClick={() => {
                        handleAddList()
                    }}
                >{fetchCommonCMSLabel("Common.Add")}</Button>
                <Button onClick={handleClose}>{fetchCommonCMSLabel("Common.Cancel")}</Button>
            </DialogActions>

        </Dialog>
    )
}
export default ManagePDFilesForSubFolderDialog